import { render, staticRenderFns } from "./AccountInfoView.vue?vue&type=template&id=371279f2"
import script from "./AccountInfoView.vue?vue&type=script&lang=js"
export * from "./AccountInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports